export const css = {
    oneaction: '_38KICyYk',
    primaryButton: '_2Uws_3io',
    microQuizWrapper: '_35jWiibe',
    microQuizHeader: 'qCHOnXJr',
    instructions: 'Z9DIUwUi',
    passed_instructions: 'a4KZXxew',
    score: '_2szGFEl3',
    actions: 'WKXfM3BN',
    ' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/prometric'
};
export default css;
